import React from 'react'
import Layout from '../../Layout/Layout'
import DataTable from './Table'

const JobOpenings = () => {
  return (
   <Layout>
     <DataTable/>
    </Layout>
  )
}

export default JobOpenings
